import React from 'react';
import { createRoot } from 'react-dom/client';
import App from 'App';
import { BrowserRouter as Router } from 'react-router-dom';
import { apiSelector } from 'helpers/api';

const myDomain = document.location.hostname;
const api = apiSelector(myDomain);

declare global {
  interface Window {
    apiBase: string;
    apiBaseFile: string;
  }
}

window.apiBase = api.main;
window.apiBaseFile = api.baseFile;

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <Router>
    <App />
  </Router>
);
